import React, { Dispatch, SetStateAction } from 'react';
import styles from './ShippingMethods.module.scss';
import classnames from 'classnames/bind';
import { ShippingMethod } from '@services/checkout';
import { formatPrice } from '@utils';
import { Price } from '@services';
import { Typography, RadioGroup, Input, RadioGroupVariant } from 'gd-design-library';

const cx = classnames.bind(styles);

const CN = 'shipping-methods';
const shippingMethodClassName = 'shipping-method';
const contentClassName = `${shippingMethodClassName}__content`;
const descriptionClassName = `${shippingMethodClassName}__description`;
const priceClassName = `${shippingMethodClassName}__price`;
const infoClassName = `${shippingMethodClassName}__info`;

const ShippingMethodInfo: React.FC<{ shippingMethod: ShippingMethod, totalPrice: Price }> = ({ shippingMethod, totalPrice }) => (
  <div>
    <div className={ cx(infoClassName) }>
      <Typography variant='h5'>
        { shippingMethod.name }
      </Typography>
      <Typography variant='h5' className={ cx(priceClassName,
        { 'free': totalPrice?.value > shippingMethod.freeAbove.value }) }
      >
        { totalPrice?.value > shippingMethod.freeAbove.value ? 'Free' : formatPrice(shippingMethod.price) }
      </Typography>
    </div>
    <Typography className={ cx(descriptionClassName) }>
      { shippingMethod.description }
    </Typography>
  </div>
);

interface ShippingMethodsProps {
    shippingMethods: ShippingMethod[];
    shippingMethodId: string;
    setShippingMethodId: Dispatch<SetStateAction<string>>;
    totalPrice: Price;
}

export const ShippingMethods: React.FC<ShippingMethodsProps> = ({
  shippingMethods,
  shippingMethodId,
  setShippingMethodId,
  totalPrice
}) => {
  const handleShippingMethodChange = (value: string): void => {
    setShippingMethodId(value);
  };

  const options = shippingMethods?.map(shippingMethod => ({
    label: shippingMethod.name,
    value: shippingMethod.id,
    payload: {
      title: shippingMethod.name,
      subtitle: shippingMethod.description,
      price: totalPrice?.value > shippingMethod.freeAbove.value ? 'FREE' : formatPrice(shippingMethod.price),
      description: shippingMethod.description
    }
  })) || [];

  const renderOption = (renderProps): React.ReactNode => {
    const { option, isSelected } = renderProps;

    return (
      <div className={ cx(shippingMethodClassName) }>
        <Input
          variant='radio'
          role='radio'
          className={ cx(contentClassName) }
          checked={ isSelected }
          onChange={ (): void => handleShippingMethodChange(option.value) }
        />
        <ShippingMethodInfo
          totalPrice={ totalPrice }
          shippingMethod={ shippingMethods?.find(method => method.id === option.value) || {} as ShippingMethod }
        />
      </div>
    );
  };

  return (
    shippingMethods && <RadioGroup
      value={ shippingMethodId }
      onChange={ handleShippingMethodChange }
      options={ options }
      renderOption={ renderOption }
      variant={ RadioGroupVariant.Column }
      align='stretch'
      className={ cx(CN) }
    />
  );
};
